import {Style} from 'exceljs';

export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
const FILL_PATTERN = 'solid';
const FILL_TYPE = 'pattern';

enum BorderStyle {
    DOTTED = 'dotted',
    THIN = 'thin',
}

export enum HorizontalAlignment {
    LEFT = 'left',
    CENTER = 'center',
    RIGHT = 'right',
}

export enum VerticalAlignment {
    TOP = 'top',
    MIDDLE = 'middle',
}

export enum Color {
    WHITE = 'FFFFFFFF',
    BLUE = 'FF4F81BD',
    LIGHT_BLUE = 'EEF3F8',
    RED = 'A12300',
}

export const createTableHeaderStyle: Partial<Style> = {
    border: {
        right: {style: BorderStyle.DOTTED},
        top: {style: BorderStyle.THIN},
    },
    alignment: {
        horizontal: HorizontalAlignment.CENTER,
        vertical: VerticalAlignment.MIDDLE,
    },
    fill: {
        type: FILL_TYPE,
        pattern: FILL_PATTERN,
        fgColor: {argb: Color.BLUE},
    },
};

export const createTableCellStyle = (rowIndex: number): Partial<Style> => {
    const backgroundColor = rowIndex % 2 === 0 ? Color.LIGHT_BLUE : Color.WHITE;

    return {
        border: {
            right: {style: BorderStyle.DOTTED},
        },
        fill: {
            type: FILL_TYPE,
            pattern: FILL_PATTERN,
            fgColor: {argb: backgroundColor},
        },
    };
};
